import { ProgressSelectors, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { SKELETON_DUMMYTEXT } from '../../base/constants';
import HighscoreCard from '../../components/HighscoreCard/HighscoreCard';
import { IProgressEntry } from '../../components/progress/ProgressGraph';
import { IState } from '../../store/state';
import * as Selectors from '../selectors';

interface IOwnProps {
  exerciseId?: string;
  className?: string;
  siblings: number[];
  locked: boolean;
  userId?: number;
}

export interface IHighscoreCardContainerProps extends IOwnProps {
  highscore: number;
  progress: IProgressEntry[];
}

const HighscoreCardContainerFC: React.FC<IHighscoreCardContainerProps> = ({
  exerciseId,
  className,
  locked,
  highscore,
  progress,
}) => {
  const { t, language } = useTranslation();
  return (
    <HighscoreCard
      locale={language}
      noDataLabel={t('Exercise.PostWorkout.NoData')}
      progress={progress}
      title={exerciseId ? t(`common.exercises:Title.${exerciseId}`) : SKELETON_DUMMYTEXT}
      scoreRecord={highscore}
      className={className}
      exerciseId={exerciseId}
      locked={locked}
    />
  );
};

export const mapStateToProps = (state: IState, ownProps: IOwnProps) => {
  const highscores: number[] = [];
  ownProps.siblings.forEach((workoutId) => {
    const highscore = Selectors.getHighscoreByWorkoutId(state, workoutId) ?? 0;
    highscores.push(highscore);
  });
  const siblingProgress =
    ProgressSelectors.getMergedProgressForWorkouts(state, ownProps.siblings, ownProps.userId) ?? [];
  const progress: IProgressEntry[] = siblingProgress
    .map((progress) => ({
      score: progress.result,
      time: progress.timestamp,
    }))
    .sort((a, b) => a.time - b.time);
  const highscore = Math.max(...highscores);
  return {
    progress,
    highscore,
  };
};

const HighscoreCardContainer = connect(mapStateToProps)(HighscoreCardContainerFC);
export default HighscoreCardContainer;
